<template>
  <!-- 绑定登陆手机号码弹窗 -->
  <el-dialog
    :title="isAuthId?'修改绑定登陆手机号码':'绑定登陆手机号码'"
    :visible.sync="visible"
    width="460px"
    @close="close"
  >
    <el-form :model="form" label-width="100px" ref="formRef" rules="rules">
      <el-form-item
        label="原手机号"
        prop="oldPhone"
        v-if="isAuthId"
      >
        <el-input
          v-model="form.oldPhone"
          placeholder="请输入当前绑定的手机号验证"
          maxlength="11"
        />
      </el-form-item>

      <!-- 新手机号 -->
      <el-form-item
        label="新手机号"
        prop="newPhone"
      >
        <el-input
          v-model="form.newPhone"
          placeholder="请输入要绑定的新手机号"
          maxlength="11"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">确认绑定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'BindPhone',
  props: {
    show: { type: Boolean, default: false },
    orgPhone: { type: String, default: '' }, // 原始手机号（父组件传）
  },
  data() {
    return {
      form: {
        oldPhone: '',
        newPhone: '',
		
      },
	  isAuthId:false,
      // 表单校验
      rules: {
        oldPhone: [
          { required: true, message: '请输入原手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确' }
        ],
        newPhone: [
          { required: true, message: '请输入新手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确' }
        ]
      },
	  login:null,
    }
  },
  computed: {
    visible: {
      get() { return this.show },
      set(val) { this.$emit('update:show', val) }
    }
  },
  created() {
  	this.isAuthId = localStorage.getItem('authId')?true:false
  },
  methods: {
	  // 加载
	  loginOpen(text) {
	  	this.login = this.$loading({
	  		lock: true,
	  		text,
	  		zIndex: 100001,
	  		spinner: 'el-icon-loading',
	  		background: 'rgba(0,0,0,0.7)'
	  	});
	  },
	  noLogin() {
	  	if (this.login) {
	  		this.login.close();
	  		this.login = null;
	  	}
	  },
    close() {
      this.form = { oldPhone: '', newPhone: '' }
      this.$emit('update:show', false)
    },
    // 提交绑定
    submit() {
      const { orgPhone } = this
      const { oldPhone, newPhone } = this.form

      // 已绑定 → 必须验证原手机号
      if (orgPhone) {
        if (!oldPhone) {
          this.$message.error('请输入原手机号')
          return
        }
        if (oldPhone !== orgPhone) {
          this.$message.error('原手机号不正确')
          return
        }
      }

      // 新手机号不能为空
      if (!newPhone) {
        this.$message.error('请输入新手机号')
        return
      }
	  this.loginOpen(`绑定手机号中...`)
	  let userType=localStorage.getItem('userType')
      const userId = localStorage.getItem('userId')
      if (!userId) {
        this.$message.error('登录信息失效，请重新登录')
        return
      }
	  let userTypeName=['','admin','school']
	  let Type=userTypeName[userType]
	  let apiname=this.API[Type].postSchoolUserBindPhone
      // 调用绑定接口
      this.API.post(apiname, {
          userId: userId,
		  oldPhone:oldPhone,
          phone: newPhone,
          platform: userType // 你后端写死的字段，保持一致
        
      }).then(res => {
		  console.log(res.data)
        if (res.data.code == 200) {
          this.$message.success('绑定成功！')
		  localStorage.setItem('authId', res.data.data)
		  this.isAuthId=true
		  this.noLogin()
          this.$emit('success') // 通知父组件刷新
		  if(this.$bus.$emit('refresh-org-logo',"phone"))
          this.close()
        } else {
          this.$message.error(res.data.msg || '绑定失败')
        }
		
      }).catch(() => {
		  this.noLogin()
        this.$message.error('绑定失败，服务异常')
      })
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>